import React from 'react';

export class VerificationPageContainer extends React.PureComponent<any> {
  // TODO: This container handles the verification link sent to a 
  // user's email or phone.
}
